import { render, staticRenderFns } from "./AppBase.vue?vue&type=template&id=3b84833e&scoped=true&"
import script from "./AppBase.vue?vue&type=script&lang=ts&"
export * from "./AppBase.vue?vue&type=script&lang=ts&"
import style0 from "./AppBase.vue?vue&type=style&index=0&id=3b84833e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b84833e",
  null
  
)

export default component.exports